
const REG_POSITION_TAGS = ['插入短位置', '插入长位置']
const setAnswer = function (qu, valueMap, otherAnswerMap) {
  const quNote = this.quNote
  if (!quNote) {
    return
  }
  const descList = []
  let configValue = []

  let tags = REG_POSITION_TAGS.join('|')
  let tagIndex = 0

  const value = valueMap[this.id]
  quNote.replace(new RegExp(tags, 'g'), text => {
    const desvValue = value[tagIndex++] || ''
    descList.push({
      value: desvValue
    })
    configValue.push(desvValue)
  })
  this.descList = descList
  this.value = configValue
}

const answer = {
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/FillBlankBox/answer.js